import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Iter 172/174 — silence noisy console floods that come from third-party libs
//   1. AG-Grid: complaining about `x-line-number`/`x-file-name` (leaked by
//      Emergent's @emergentbase/visual-edits plugin onto every <AgGridReact/>).
//   2. AG-Grid Enterprise license banner — printed as console.error with
//      asterisk decorations on every grid mount. App uses Community edition.
const _origWarn = console.warn.bind(console);
const _origErr = console.error.bind(console);
const _origLog = console.log.bind(console);

function _isAgGridLicenseStars(args) {
  const s = typeof args[0] === 'string' ? args[0] : '';
  return /\*{6,}|AG Grid Enterprise|License Key Not Found|use a Grid Enterprise license/.test(s);
}

console.warn = (...args) => {
  const msg = typeof args[0] === 'string' ? args[0] : '';
  if (
    msg.includes('invalid gridOptions property') &&
    /'x-(line-number|file-name|dynamic|component|id|source-type|source-editable|column|file-path)'/.test(msg)
  ) return;
  if (_isAgGridLicenseStars(args)) return;
  _origWarn(...args);
};
console.error = (...args) => {
  if (_isAgGridLicenseStars(args)) return;
  _origErr(...args);
};
console.log = (...args) => {
  if (_isAgGridLicenseStars(args)) return;
  _origLog(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA / offline support (Module 3.2 mobile audit)
if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'development') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Silent fail — SW unavailable should not break the app
    });
  });
}
